import type { AgentSseEvent } from '../agentEvent'

// バックエンド（apps/backend/web/routers/aiChat.ts の writeSseEvent）が実際に書き込む形式と
// 完全に一致させる（改行は `\n` 固定・1イベントの data は必ず1行）。この関数を fixtures と
// バックエンドの契約テスト（packages/backend/ai-agent/test）の両方から使うことで、
// 「フィクスチャ＝サーバーが実際に流す形」を保証する
export function buildSseWireText(events: AgentSseEvent[]): string {
  return events.map((event) => `event: ${event.type}\ndata: ${JSON.stringify(event)}\n\n`).join('')
}
